import {useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetBugReportIssues} from '../services/bugReporter.http'

export const useGetBugReportIssues = ({enabled}: {enabled: boolean}) =>
    useQuery({
        queryKey: [QUERY_KEYS.BUG_REPORTER_ISSUES],
        queryFn: () => httpGetBugReportIssues(),
        enabled,
        // The history reflects work picked up by the dev team — keep it reasonably fresh.
        staleTime: 60000
    })
